import type { AuthUser, Profile } from '@/types';

export const mockAuthUsers: AuthUser[] = [
  {
    id: 'op-001',
    email: 'operator@leadnetwork.io',
    role: 'operator',
    partner_id: null,
    full_name: 'System Operator'
  },
  {
    id: 'am-001',
    email: 'account.mgr@leadnetwork.io',
    role: 'account_manager',
    partner_id: null,
    full_name: 'Account Manager'
  },
  {
    id: 'pp-001',
    email: 'sam@vandijklegal.nl',
    role: 'partner_principal',
    partner_id: 'partner-001',
    full_name: 'Sam van Dijk'
  },
  {
    id: 'ps-001',
    email: 'assistant@vandijklegal.nl',
    role: 'partner_staff',
    partner_id: 'partner-001',
    full_name: 'Sarah Assistant'
  },
  {
    id: 'ro-001',
    email: 'investor@leadnetwork.io',
    role: 'read_only',
    partner_id: null,
    full_name: 'Read-Only Investor'
  },
  {
    id: 'akwasi-001',
    email: 'n.akwasi.domfeh@gmail.com',
    role: 'operator',
    partner_id: null,
    full_name: 'Akwasi Domfeh'
  },
  {
    id: 'pp-002',
    email: 'mark@pvcvloer.nl',
    role: 'partner_principal',
    partner_id: 'partner-003',
    full_name: 'Mark de Vries'
  },
  {
    id: 'pp-003',
    email: 'mike@goldmanrealty.com',
    role: 'partner_principal',
    partner_id: 'partner-002',
    full_name: 'Michael Goldman'
  },
  {
    id: 'pp-pvc-001',
    email: 'partner@pvcvloer.net',
    role: 'partner_principal',
    partner_id: 'partner-003',
    full_name: 'PVC Vloer Amsterdam'
  }
];

export const mockProfiles: Profile[] = mockAuthUsers.map(u => ({
  id: u.id,
  role: u.role,
  partner_id: u.partner_id,
  assigned_partner_ids: u.role === 'account_manager' ? ['partner-001', 'partner-002'] : [],
  full_name: u.full_name,
  preferred_language: 'en',
  notification_email: true,
  notification_whatsapp: false,
  created_at: '2024-01-01T00:00:00Z',
  last_login_at: '2025-05-01T10:00:00Z'
}));